/* The Faculty 3 cover, coming to life in the shop's hero.
   The soft-focus hummingbird is an <img> filling the hero; this canvas lays the cover's
   ASCII artwork over it in register, exactly where InDesign places it on the page (the
   placement is in club-ascii.json), multiplied in near-black as it prints. The 25 accent
   words keep their printed colours and never change; every other character now and then
   switches to another of the same weight and comes back, and scrambles under the pointer.
   Around the words in the hero the artwork thins, so they read. */
(function () {
  const canvas = document.querySelector('[data-club-ascii]');
  if (!canvas) return;
  const host = canvas.parentElement;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fonts = JSON.parse(canvas.dataset.fonts);
  const INK = canvas.dataset.ink || '20,20,20';
  const SETS = [                       // replacement letters by ink density, as on the reel
    ['Butter', 'cnuvzo:~-'],
    ['Butter', 'L7JYt?[]CTVnu'],
    ['Cake', 'PUdbqp90O8Z'],
    ['Cake', 'PUdbq8DOEHK#*&'],
    ['Glob', 'MNWBEH#&DKRQ'],
  ];
  const DOTS = ['Butter', '.:-~\',`'];
  const setFor = lv => lv <= 0 ? SETS[0] : lv === 1 ? SETS[1] : lv === 2 ? SETS[2] : lv <= 4 ? SETS[3] : SETS[4];
  const hash = (a, b, s) => { let h = (a * 374761393 + b * 668265263 + s * 2147483647) | 0; h = (h ^ (h >>> 13)) * 1274126177; return ((h ^ (h >>> 16)) >>> 0) / 4294967296; };

  let data, cells = [], map = new Map(), ctx, W = 0, H = 0, cw = 0, rh = 0, size = 0;
  const ptr = { x: -1e4, y: -1e4 };

  function layout() {
    const r = host.getBoundingClientRect();
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    W = r.width; H = r.height;
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    ctx = canvas.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // the photo spans `photo` on the page, in pt. It is set a little taller than the hero
    // and placed so the bird's own centre (BIRD, in page pt) lands in the middle of the
    // hero; a blurred copy of the same photo fills whatever the sharp one does not reach.
    const [px0, py0, side] = data.place.photo;
    const BIRD = [262, 395];
    const s = Math.max(H * 1.12 / side, W * 0.5 / side);
    const left = W / 2 - (BIRD[0] - px0) * s, top = H / 2 - (BIRD[1] - py0) * s;
    const X = pt => left + (pt - px0) * s, Y = pt => top + (pt - py0) * s;
    // the picture is the photo extended outward (data.place.ext, in pt): place that, so the
    // soft ground runs on to every edge with no frame
    const photo = host.querySelector('.club-hero__bg');
    if (photo) {
      const [ex, ey, ew, eh] = data.place.ext;
      Object.assign(photo.style, { left: X(ex) + 'px', top: Y(ey) + 'px', width: ew * s + 'px', height: eh * s + 'px' });
      photo.classList.add('is-placed');
    }
    const A = data.place.as;
    cw = A * data.cw * s; rh = A * data.rh * s; size = A * 7.2 * s;

    const t = host.querySelector('[data-clear]');
    const tr = t ? t.getBoundingClientRect() : null;
    const clear = tr ? { x0: tr.left - r.left - 18, x1: tr.right - r.left + 18, y0: tr.top - r.top - 14, y1: tr.bottom - r.top + 14 } : null;

    const words = new Map(data.words.map(([wr, wc, ch, col]) => [wr + ',' + wc, [ch, col]]));
    cells = []; map = new Map();
    // the artwork's grid, carried on past the artwork to every edge of the hero
    const r0 = Math.floor((0 - Y(data.place.ay)) / rh) - 1, r1 = Math.ceil((H - Y(data.place.ay)) / rh) + 1;
    const c0 = Math.floor((0 - X(data.place.ax)) / cw) - 1, c1 = Math.ceil((W - X(data.place.ax)) / cw) + 1;
    const mod = (a, n) => ((a % n) + n) % n;
    for (let row = r0; row < r1; row++) {
      const y = Y(data.place.ay + A * row * data.rh);
      for (let col = c0; col < c1; col++) {
        const x = X(data.place.ax + A * col * data.cw);
        const inside = row >= 0 && row < data.rows && col >= 0 && col < data.cols;
        const word = inside ? words.get(row + ',' + col) : null;
        let set, alpha;
        if (inside) {
          const g = data.grid[row][col];
          if (!word && g === ' ') continue;
          if (word) { set = null; alpha = 1; }
          else if (g >= '0' && g <= '9') { set = setFor(+g); alpha = 0.92; }
          else { set = DOTS; alpha = 0.6; }
        } else {
          // outside: the cover's own dot texture, tiled, with now and then a string of
          // light letters running through it, as the printed field does
          const g = data.grid[mod(row, data.rows)][mod(col, data.cols)];
          const run = hash(row, Math.floor(col / 9), 11) < 0.09 && hash(row, col, 12) < 0.85;
          if (run) { set = SETS[hash(row, Math.floor(col / 9), 13) < 0.5 ? 0 : 1]; alpha = 0.75; }
          else if (g === ' ') continue;
          else { set = DOTS; alpha = 0.6; }
        }
        if (clear) {
          const d = Math.hypot(Math.max(0, clear.x0 - x, x - clear.x1), Math.max(0, clear.y0 - y, y - clear.y1));
          alpha *= word ? Math.min(1, 0.35 + d / 50) : Math.min(1, 0.08 + d / 70);
        }
        if (alpha < 0.03) continue;
        const base = word ? word[0] : set[1][Math.floor(hash(row, col, 1) * set[1].length)];
        const cell = { row, col, x, y: y + rh * 0.78, set, alpha, ink: word ? word[1] : null, base, ch: base,
                       next: performance.now() + hash(row, col, 3) * 6000, back: 0 };
        cells.push(cell); map.set(row + ',' + col, cell);
      }
    }
    ctx.clearRect(0, 0, W, H);
    cells.forEach(paint);
  }

  function paint(c) {
    ctx.font = `${size}px "CLUB ${c.set ? c.set[0] : 'Cake'}"`;
    ctx.fillStyle = c.ink || `rgb(${INK})`;
    ctx.globalAlpha = c.alpha;
    ctx.fillText(c.ch, c.x, c.y);
    ctx.globalAlpha = 1;
  }

  function repaint(list) {
    ctx.save(); ctx.beginPath();
    list.forEach(c => { ctx.clearRect(c.x, c.y - rh * 0.82, cw, rh); ctx.rect(c.x, c.y - rh * 0.82, cw, rh); });
    ctx.clip();
    // a glyph can overhang its cell: repaint the neighbours on the row so nothing is nicked
    const again = new Set(list);
    list.forEach(c => [-1, 1].forEach(d => { const n = map.get(c.row + ',' + (c.col + d)); if (n) again.add(n); }));
    again.forEach(paint);
    ctx.restore();
  }

  let last = 0;
  function tick(now) {
    requestAnimationFrame(tick);
    if (now - last < 1000 / 24) return;
    last = now;
    const changed = [];
    for (const c of cells) {
      if (!c.set) continue;
      const dx = c.x - ptr.x, dy = c.y - ptr.y;
      if (dx * dx + dy * dy < 4900 && Math.random() < 0.35) {
        c.ch = c.set[1][Math.floor(Math.random() * c.set[1].length)]; c.back = now + 400 + Math.random() * 500; changed.push(c);
      } else if (c.back && now > c.back) {
        c.ch = c.base; c.back = 0; changed.push(c);
      } else if (now > c.next) {
        c.ch = c.set[1][Math.floor(Math.random() * c.set[1].length)];
        c.back = now + 300 + Math.random() * 900;
        c.next = now + 2500 + Math.random() * 7000;
        changed.push(c);
      }
    }
    if (changed.length) repaint(changed);
  }

  async function start() {
    const faces = Object.entries(fonts).map(([n, url]) => new FontFace('CLUB ' + n, `url(${url})`).load().then(f => document.fonts.add(f)));
    const [json] = await Promise.all([fetch(canvas.dataset.src).then(r => r.json()), ...faces]);
    data = json;
    layout();
    host.classList.add('is-live');
    let t; addEventListener('resize', () => { clearTimeout(t); t = setTimeout(layout, 150); });
    if (still) return;
    host.addEventListener('pointermove', e => { const r = host.getBoundingClientRect(); ptr.x = e.clientX - r.left; ptr.y = e.clientY - r.top; });
    host.addEventListener('pointerleave', () => { ptr.x = ptr.y = -1e4; });
    requestAnimationFrame(tick);
  }
  start();
})();
